import { removeHtmlTags } from '../../../utils/DOM';
const formatAriaLabelText = (t, labelProps = {}) => {
    const { title, transmissionName, exteriorColorName, interiorColorName, inventoryStatus } = labelProps;
    if (!title || !transmissionName || !exteriorColorName || !interiorColorName || !inventoryStatus) {
        return null;
    }
    const ariaLabel = t('Shared.Common.trimCardAria', {
        title: removeHtmlTags(title),
        transmissionName,
        exteriorColorName,
        interiorColorName,
        inventoryStatus,
    });
    return ariaLabel;
};
export default formatAriaLabelText;
